const track = (ReactGA, action) => {
  //console.log(action);
  ReactGA.event({ category: "User", action });
};

export default track;
